// Module
var code = "<template> <require from=\"app/cm/components/household/current-case-routing-grid\"></require> <current-case-routing-grid household-case-id.bind=\"householdCaseId\"></current-case-routing-grid> </template> ";
// Exports
module.exports = code;